import axios from '@/utils/api'

const actions = {
  download ({ commit }, file) {
    return axios({
      method: 'POST',
      responseType: 'blob',
      data: file,
      url: `anexoMensagem/download`
    })
  },

  async downloadDocument  ({ commit }, file) {
    const fileDownload = await axios({
      method: 'POST',
      url: `documento/file`,
      data: file,
      responseType: 'blob'
    })

    return fileDownload
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/download.js